/* udp-skeleton-loading.css */
.skeleton-loader {
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 1000px 100%;
    display: inline-block;
    position: relative;
    overflow: hidden;
  }
  
  /* Animation */
  .skeleton-loader::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.5), transparent);
    animation: load 1.5s infinite;
  }
  
  @keyframes load {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  